import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../common/common_components/pagination_holder/Pagination_Holder";

const Table = ({ setEdit }) => {
  const data = [
    {
      chemistId: "CHE1001",
      roleName: "Lab In-Charge",
      name: "Rahul Mane",
      gender: "Male",
      contactNo: "7836251609",
      email: "rahulmane@gmail.com",
      status: "Active",
    },
    {
      chemistId: "CHE1002",
      roleName: "Lab Manager",
      name: "Paresh M.",
      gender: "Male",
      contactNo: "2345251609",
      email: "pareshm12@gmail.com",
      status: "Inactive",
    },
    {
      chemistId: "CHE1003",
      roleName: "Lab Technician",
      name: "Sonu Buradkar",
      gender: "Female",
      contactNo: "8763525160",
      email: "sonuburadkar12@gmail.com",
      status: "Active",
    },
    {
      chemistId: "CHE1004",
      roleName: "Quality Manager",
      name: "Prathamesh Raut",
      gender: "Male",
      contactNo: "7836251609",
      email: "raut1004@gmail.com",
      status: "Inactive",
    },
    {
      chemistId: "CHE1005",
      roleName: "Accounts Role",
      name: "Oshin Kawale",
      gender: "Male",
      contactNo: "2345251609",
      email: "oshinkawale@gmail.com",
      status: "Active",
    },
    {
      chemistId: "CHE1006",
      roleName: "Instrument Engineer",
      name: "Sanket Thawari",
      gender: "Male",
      contactNo: "8763525160",
      email: "sanketthawari@gmail.com",
      status: "Active",
    },
    {
      chemistId: "CHE1007",
      roleName: "Auditor / External Assessor (View Only)",
      name: "Kiran Falmari",
      gender: "Male",
      contactNo: "2345251609",
      email: "kiranfalmari1234@gmail.com",
      status: "Active",
    },
  ];

     const getStatusClass = (status) => {
    switch (status) {
      case "Active":
        return "green";
      case "Inactive":
        return "red";
      default:
        return "";
    }
  };
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            <thead>
              <tr>
                <th>Chemist ID</th>
                <th>Role Name</th>
                <th>Name</th>
                <th>Gender</th>
                <th>Contact No</th>
                <th>Email</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {data.map((row, index) => (
                <tr key={index} className={index % 2 !== 0 ? "striped" : ""}>
                  <td>{row.chemistId}</td>
                  <td>{row.roleName}</td>
                  <td>{row.name}</td>
                  <td>{row.gender}</td>
                  <td>{row.contactNo}</td>
                  <td>{row.email}</td>
                   <td className={`status ${getStatusClass(row.status)}`}>
                    {row.status}
                  </td>
                  <td>
                    <div
                      className="edit_icon_holder"
                      onClick={() => {
                        setEdit(true);
                      }}
                    >
                      <FontAwesomeIcon icon={faPencil} className="edit_icon" />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">Showing 1 To 16 Of 16 Entries</p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default Table;
